import { API_BASE_URL } from "../config/apiBaseUrl";

const ADMIN_BASE = "/api/admin/automotive";

function authHeaders() {
  return { credentials: "include", headers: { "Content-Type": "application/json" } };
}

function qs(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== "") search.set(key, value);
  });
  const q = search.toString();
  return q ? `?${q}` : "";
}

export async function fetchPlaybookHub(filters = {}) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/playbook${qs(filters)}`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar el playbook.");
  return res.json();
}

export async function fetchPlaybookSection(slug, filters = {}) {
  const res = await fetch(
    `${API_BASE_URL}${ADMIN_BASE}/playbook/sections/${encodeURIComponent(slug)}${qs(filters)}`,
    authHeaders()
  );
  if (res.status === 404) throw new Error("Sección no encontrada.");
  if (!res.ok) throw new Error("No se pudo cargar la sección.");
  return res.json();
}

export async function searchPlaybook(query, filters = {}) {
  const res = await fetch(
    `${API_BASE_URL}${ADMIN_BASE}/playbook/search${qs({ q: query, ...filters })}`,
    authHeaders()
  );
  if (!res.ok) throw new Error("Error en búsqueda.");
  return res.json();
}

export async function fetchPlaybookTemplates(filters = {}) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/playbook/templates${qs(filters)}`, authHeaders());
  if (!res.ok) throw new Error("No se pudieron cargar plantillas.");
  return res.json();
}

export async function copyPlaybookTemplate(templateId) {
  const res = await fetch(
    `${API_BASE_URL}${ADMIN_BASE}/playbook/templates/${encodeURIComponent(templateId)}/copy`,
    { method: "POST", ...authHeaders() }
  );
  if (!res.ok) throw new Error("No se pudo registrar copia.");
  return res.json();
}

export async function fetchPlaybookChecklists(filters = {}) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/playbook/checklists${qs(filters)}`, authHeaders());
  if (!res.ok) throw new Error("No se pudieron cargar checklists.");
  return res.json();
}

export async function fetchPlaybookChecklist(checklistId) {
  const res = await fetch(
    `${API_BASE_URL}${ADMIN_BASE}/playbook/checklists/${encodeURIComponent(checklistId)}`,
    authHeaders()
  );
  if (!res.ok) throw new Error("Checklist no encontrada.");
  return res.json();
}

export async function updatePlaybookChecklistItem(checklistId, itemId, patch) {
  const res = await fetch(
    `${API_BASE_URL}${ADMIN_BASE}/playbook/checklists/${encodeURIComponent(checklistId)}/items/${encodeURIComponent(itemId)}`,
    { method: "PATCH", ...authHeaders(), body: JSON.stringify(patch) }
  );
  if (!res.ok) throw new Error("No se pudo actualizar ítem.");
  return res.json();
}

export async function trackPlaybookRouteClick(slug, href) {
  await fetch(`${API_BASE_URL}${ADMIN_BASE}/playbook/related-route-click`, {
    method: "POST",
    ...authHeaders(),
    body: JSON.stringify({ slug, href }),
  }).catch(() => {});
}
